import { useEffect, useState } from 'react'

export const useProfile = () => {
    const [profileCompleteness, setProfileCompleteness] = useState(15);

    useEffect(() => {
        setProfileCompleteness(JSON.parse(localStorage.getItem("data"))?.profile_completeness || 15);
    }, [profileCompleteness]);

    return {
        profileCompleteness
    }
}
